import { useEffect, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';

import { Button, Input } from '../../components';
import { ArrowBack } from '../../components/Icons/ArrowBack';
import { Auth } from '../../helpers/amplifyAuthCompat';
import { alertActions } from '../../redux/actions/alertActions';
import { login } from '../../redux/actions/auth';
import { loadingActions } from '../../redux/actions/loadingActions';

const schema = yup.object().shape({
	email: yup.string().email('E-mail inválido').required('Es requerido'),
	pass: yup.string().required('Es requerido'),
});

export const FormLogin = ({ smt, setSmt, setType }) => {
	const dispatch = useDispatch();

	const bgc = `#${process.env.REACT_APP_TOOLBAR_COLOR}`;

	//Login timer
	const [loginAttempts, setLoginAttempts] = useState(
		parseInt(localStorage.getItem('loginAttempts') || '0', 10) || 0,
	);
	const [timer, setTimer] = useState(
		parseInt(localStorage.getItem('loginTimer') || '0', 10) || 0,
	);

	// Initialize on mount
	useEffect(() => {
		// Check if a timer end time is saved in localStorage
		const timerEnd = parseInt(localStorage.getItem('loginTimerEnd') || '0', 10);
		if (timerEnd) {
			// Calculate the difference between the current time and the end time
			const timeLeft = timerEnd - Date.now();
			if (timeLeft > 0) {
				// Set the remaining time on the timer
				setTimer(Math.ceil(timeLeft / 1000));
			}
		}
	}, []);

	// Update localStorage when timer updates
	useEffect(() => {
		if (timer > 0) {
			// Save the timer end time in localStorage
			localStorage.setItem(
				'loginTimerEnd',
				(Date.now() + timer * 1000).toString(),
			);
		} else {
			// Clear the timer from localStorage when it reaches 0
			localStorage.removeItem('loginTimerEnd');
			localStorage.removeItem('loginAttemptIncrement');
		}
		localStorage.setItem('loginAttempts', loginAttempts.toString());
	}, [timer, loginAttempts]);

	// Decrement timer every second
	useEffect(() => {
		let interval = null;
		if (timer > 0) {
			interval = setInterval(() => {
				setTimer((prevTimer) => prevTimer - 1);
			}, 1000);
		}
		return () => clearInterval(interval);
	}, [timer]);

	useEffect(() => {
		dispatch(loadingActions.close());
		// user comes from AzureAD login
		Auth.currentAuthenticatedUser()
			.then((federatedUser) => {
				dispatch(login(federatedUser.username, []));
			})
			.catch((err) => {
				if (err !== 'The user is not authenticated') {
					console.error('LOGIN >> AUTH ERROR', err);
				}
			});
	}, []);

	const hookForm = useForm({
		resolver: yupResolver(schema),
	});

	const { handleSubmit } = hookForm;

	const onSubmitHandler = (data, e) => {
		e.preventDefault();
		dispatch(loadingActions.show());

		Auth.signIn(data.email, data.pass)
			.then(() => {
				dispatch(login(data.email, []));
				setTimer(0);
				localStorage.removeItem('loginTimerEnd');
				localStorage.removeItem('loginAttemptIncrement');
				localStorage.setItem('loginAttempts', '0');
			})
			.catch((_err) => {
				// Incorrect password, increment the timer
				const newLoginAttempts = loginAttempts + 1;
				const increment = Math.max(newLoginAttempts - 3, 0) * 15;
				setTimer(increment);
				setLoginAttempts(newLoginAttempts);
				localStorage.setItem('loginAttempts', String(newLoginAttempts));

				dispatch(
					alertActions.danger({
						message: 'Correo o contraseña incorrectos.',
					}),
				);
				dispatch(loadingActions.close());
			});
	};

	const loginFederado = () => {
		Auth.federatedSignIn({
			customProvider: 'AzureAD',
		});
	};

	return (
		<div className={`login__form ${!smt && 'is-smt'}`}>
			<div className="login__title">
				{!smt ? (
					<>
						<span>Iniciar</span> sesión
					</>
				) : (
					<>
						Usuario y contraseña <span>SMT</span>
					</>
				)}
			</div>
			{!smt && (
				<>
					<div
						className="login__subtitle is-red"
						onClick={() => loginFederado()}
					>
						Con tu cuenta RIMAC
					</div>
					<div className="login__subtitle is-red" onClick={() => setSmt(true)}>
						Usuario y contraseña SMT
					</div>
				</>
			)}

			<form onSubmit={handleSubmit(onSubmitHandler)}>
				<div className="back" onClick={() => setSmt(false)}>
					<ArrowBack className="back__arrow" />
					Volver
				</div>
				<Input name="email" hookForm={hookForm} placeholder="Correo" />
				<Input
					name="pass"
					hookForm={hookForm}
					type="password"
					placeholder="Contraseña"
				/>
				<div className="form__bottom">
					<Button
						type="submit"
						text="Ingresar"
						size="medium"
						style={{ backgroundColor: bgc }}
						disabled={timer > 0}
					/>
					<span className="grey__span" onClick={() => setType('forgot')}>
						Recuperar
					</span>
				</div>
			</form>
			{timer > 0 && (
				<p className="grey__text">
					Debes esperar {timer} segundos antes de volver a intentar.
				</p>
			)}
		</div>
	);
};
